module.exports = __webpack_public_path__ + "img/createBoard.9fc84488.gif";